<template>
    <div class="mt-4">
        <p class="is-size-7 is-uppercase has-text-grey-light has-text-weight-bold mb-2">
            {{ translate("admin_schedules_list.delete.select_categories_label") }}
        </p>

        <div v-if="store.categories.length === 0" class="notification is-info has-no-glow-effect">
            <p class="has-text-centered">{{ translate("admin_schedules_list.delete.empty_scope_info") }}</p>
        </div>
        <SelectionList
            v-else
            :options="store.categories"
            v-model="selectedCategories"
            multi-select
            :comparing-function="(a, b) => a.parameterId === b.parameterId"
            :is-option-disabled="category => category.hasFinishedFights"
        >
            <template v-slot:option="{ option: category }">
                <div class="is-flex is-justify-content-space-between is-align-items-center is-flex-grow-1 py-2">
                    <span class="has-text-white has-text-weight-semibold">{{ category.name }}</span>
                    <div class="is-flex is-align-items-center">
                        <p class="is-size-7 has-text-grey-light mr-4">
                            {{ translate("admin_schedules_list.delete.fights_total", false, [category.totalFights]) }}
                        </p>
                        <div class="tags mb-0">
                            <span v-if="category.hasFinishedFights" class="tag is-danger">
                                {{ translate("admin_schedules_list.delete.status_finished") }}
                            </span>
                            <span v-if="category.isDivided" class="tag is-info">
                                {{ translate("admin_schedules_list.delete.status_spans_schedules") }}
                            </span>
                            <span v-if="!category.hasFinishedFights && !category.isDivided" class="tag is-success">
                                {{ translate("admin_schedules_list.delete.status_ready") }}
                            </span>
                        </div>
                    </div>
                </div>
            </template>
        </SelectionList>
    </div>
</template>

<script setup lang="ts">
    import { computed } from "vue";
    import { translate } from "../../Common/translations";
    import SelectionList from "../../Common/SelectionList.vue";
    import { CategoryStatus, useDeletingFightsStore } from "./useDeletingFightsStore";

    const store = useDeletingFightsStore();

    const selectedCategories = computed<CategoryStatus[]>({
        get: () => store.categories.filter(category => store.selectedCategoryIds.includes(category.parameterId)),
        set: newSelection => store.setSelectedCategories(newSelection),
    });
</script>
